import React, { useEffect, useState } from 'react'
import './OrderInfoComponent.css'
import { useParams } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import DishToOrderComponent from '../DishToOrderComponent/DishToOrderComponent'
import DishComponent from '../ProdInfoComponents/DishComponent'
import TicketComponent from '../ProdInfoComponents/TicketComponent'
import { useAppContext } from '../../AppContext'
import useOneSignal from '../../onesignal'
import QRCode from 'qrcode.react'
import Box from '@mui/system/Box'
import { InputPhoneNumber } from './InputPhoneNumber'
import axios from 'axios'
import RegisterPoints from './RegisterPoints'

const OrderInfoComponent = () => {
  const { tokenVariable } = useAppContext()
  const [order, setOrder] = useState(null)
  const [orderStatus, setOrderStatus] = useState(null)
  const [dishToOrder, setDishToOrder] = useState(false)
  const { id } = useParams()

  useEffect(() => {
    if (id) {
      localStorage.setItem('auth_orderId', id)
    }
  }, [id])

  const truncateToTwoDecimals = num => {
    return Math.floor(num * 100) / 100
  }

  useEffect(() => {
    const playSound = () => {
      if (audioPlayed < 20) {
        try {
          const audio = new Audio('/audio/ring.mp3')
          audio.play()
          audioIsPlaying = true
          audioPlayed++
        } catch (e) {
          console.log('bład')
        }
      } else {
        audioIsPlaying = false
      }
    }

    var audioPlayed = 0
    var audioIsPlaying = false

    console.log(id)

    if (id) {
      const fetchOrderData = async () => {
        var requestData = { id: id }
        try {
          audioIsPlaying = false
          const response = await fetch(process.env.REACT_APP_API_URL + '/getOrder', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
          })
          const data = await response.json()

          console.log(data.bill.status)
          if (typeof data.bill.status === 'number') {
            switch (data.bill.status) {
              case 1:
                setOrderStatus('Roboczy')
                break
              case 2:
                setOrderStatus('Wysłane')
                break
              case 3:
                setOrderStatus('Zapłacone')
                break
              case 4:
                setOrderStatus('Otrzymane')
                break
              case 5:
                setOrderStatus('W przygotowaniu')
                break
              case 6:
                setOrderStatus('Gotowe')
                break
              case 7:
                setOrderStatus('W dostawie')
                break
              case 8:
                setOrderStatus('Dostarczone')
                break
              case 9:
                setOrderStatus('Płatność rozpoczęta')
                break
              case 10:
                setOrderStatus('Zakończone')
                break
              case 11:
                setOrderStatus('Wydane')
                break
              case 0:
                setOrderStatus('Anulowane')
                break
              default:
                setOrderStatus('W przygotowaniu')
                break
            }
          }

          setOrder(data)
          var toTaken = false
          if (data.bill) {
            data.bill.products.map((item, index) => {
              if (item.status === 2) {
                toTaken = true
              }
              return item
            })
            if (toTaken) {
              setDishToOrder(true)
              if (!audioIsPlaying) {
                playSound()
              }
            } else {
              setDishToOrder(false)
            }

            const tokenOneSignal = tokenVariable
            console.log(tokenOneSignal)
            if (tokenOneSignal) {
              var sendToken = false
              if (!('notify' in data.bill)) {
                sendToken = true
              } else {
                if (Array.isArray(data.bill.notify)) {
                  if ('fcm' in data.bill.notify) {
                    if (Array.isArray(data.bill.notify.fcm)) {
                      if (data.bill.notify.fcm.includes(tokenOneSignal)) {
                        sendToken = false
                      } else {
                        sendToken = true
                      }
                    } else {
                      sendToken = true
                    }
                  } else {
                    sendToken = true
                  }
                } else {
                  sendToken = true
                }
              }

              if (sendToken) {
                const notifyRequest = {
                  fcm: tokenOneSignal,
                  phone: null
                }
                try {
                  await fetch(process.env.REACT_APP_API_URL + '/saveOrderPagingData', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(notifyRequest)
                  })
                } catch (error) {
                  console.error('Wystąpił błąd podczas zapisu tokenu', error)
                }
              }
            }
          }
        } catch (error) {
          console.error('Wystąpił błąd podczas pobierania danych:', error)
        }
      }

      fetchOrderData()

      const interval = setInterval(() => {
        fetchOrderData()
      }, 5000)

      return () => clearInterval(interval)
    }
  }, [id, tokenVariable])

  const storedToken = localStorage.getItem('token')

  return (
    <div style={{ width: '100%' }}>
      {order ? (
        <Container maxWidth='lg'>
          <Grid container spacing={5}>
            <Grid item xs={6} sm={6} textAlign='left'>
              <span className='element-lokal'>Lokal:</span>
              {order.local.logo ? (
                <div className='element-nr-zam-num'>
                  <img
                    src={'https://haproxy.abspos.pl/media/' + order.local.logo}
                    className='logo'
                    alt={order.local.name}
                  />
                </div>
              ) : (
                <div className='element-local-name'>{order.local.name}</div>
              )}
            </Grid>
            <Grid item xs={6} sm={6} textAlign='right'>
              <span className='element-nr-zam'>Numer zamówienia:</span>
              <div className='element-nr-zam-num'>{id.slice(0, 8)}</div>
            </Grid>
          </Grid>
          <Grid container>
            {order.bill.products.map((item, index) => {
              switch (item.product.product_type) {
                case 7:
                  return <TicketComponent item={item} order={order.bill.id} index={index} key={index} />
                default:
                  return <DishComponent item={item} order={order.bill.id} index={index} key={index} />
              }
            })}
          </Grid>
          <Grid container paddingTop='10px' direction='row' color='rgba(0, 163, 255, 0.43)'>
            <Grid item xs={7} sm={7}></Grid>
            <Grid item xs={12} sm={12} style={{ marginTop: 'auto', backgroundColor: '#00A3FF1F', borderRadius: '8px' }}>
              <Grid container direction='row'>
                <Grid item xs={3} sm={3}>
                  <span
                    style={{
                      fontSize: '24px',
                      margin: '5px',
                      whiteSpace: 'nowrap',
                      fontFamily: 'Poppins',
                      fontWeight: '600'
                    }}
                  >
                    Suma zamówienia:
                  </span>
                </Grid>
                <Grid item xs={9} sm={9} textAlign='right' style={{ paddingRight: '10px', marginTop: '-6px' }}>
                  <div className='element-suma'>
                    <span className='liczba'>{truncateToTwoDecimals(order.bill.sum)}</span>
                    <span className='szt'> zł</span>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {order.local.local_type !== 'ICERINK' && (
            <Grid item xs={5} sm={5}>
              <Grid className='prp-punkt'>
                <RegisterPoints orderId={id} storedToken={storedToken} />
              </Grid>
              <Grid container spacing={1} direction='row' className='legenda-row'>
                <Grid item xs={3} sm={3} className='status-preparing'></Grid>
                <Grid item xs={9} sm={9} className='legenda'>
                  W przygotowaniu
                </Grid>
              </Grid>
              <Grid container spacing={1} direction='row' className='legenda-row'>
                <Grid item xs={3} sm={3} className='status-ready'></Grid>
                <Grid item xs={9} sm={9} className='legenda'>
                  Do odbioru
                </Grid>
              </Grid>
              <Grid container spacing={1} direction='row' className='legenda-row'>
                <Grid item xs={3} sm={3} className='status-taken'></Grid>
                <Grid item xs={9} sm={9} className='legenda'>
                  Wydane
                </Grid>
              </Grid>
            </Grid>
          )}

          {dishToOrder ? <DishToOrderComponent /> : null}
        </Container>
      ) : (
        <div></div>
      )}
    </div>
  )
}

export default OrderInfoComponent
